import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

export const fetchProductionPlanningQueryFn = async (
  orderId: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.get(
    `/orders/${orderId}/production-planning`,
    {
      withCredentials: false,
      signal,
    },
  );

  const result = responseDataFormate(response.data);

  if (result?.success) {
    return result?.data;
  } else {
    throw new Error(result?.message || "Failed to fetch production planning");
  }
};
